"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudiencePicker = void 0;
var _hooks = require("../../hooks");
var _AudiencePicker = _interopRequireDefault(require("./AudiencePicker.styles"));
var _views = require("./views");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AudiencePicker = props => {
  const {
    isSessionDataReady
  } = (0, _hooks.useSessionData)();
  const {
    isDeviceDataReady
  } = (0, _hooks.useDeviceData)();
  const {
    userIds,
    itemSchoolId,
    groupsIds,
    classesIds,
    studentsIds,
    view
  } = props;
  const styles = (0, _AudiencePicker.default)(props);
  if (!isSessionDataReady || !isDeviceDataReady) {
    //Loading
    return null;
  }
  if (!userIds || userIds.length === 0 || !itemSchoolId) {
    //Not Login
    return null;
  }
  if (!groupsIds || !classesIds || !studentsIds) {
    //No Audience
    return null;
  }
  if (groupsIds.length === 0 && classesIds.length === 0 && studentsIds.length === 0) {
    //No Groups Or Class
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-AudiencePicker'],
    children: [view === 'inline' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_views.ViewInline, {
      ...props
    }), view === 'groupsSelector' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_views.ViewGroupsSelector, {
      ...props
    }), view === 'studentsSelector' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_views.ViewStudentsSelector, {
      ...props
    }), view === 'createGroup' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_views.ViewCreateGroup, {
      ...props
    })]
  });
};
exports.AudiencePicker = AudiencePicker;